























import { Component, Prop, Vue } from 'vue-property-decorator'

import MobileMessageItem from './MobileMessageItem.vue'
@Component({
  components: { MobileMessageItem },
})
export default class MobileMessageLayout extends Vue {
  isOpen = true

  @Prop({ default: '' })
  searchQuery!: string

  editSearch(val) {
    this.$emit('update:search', val)
  }
}
